import React, { useState } from 'react';
import {
  Form,
  TextInput,
  Button,
  Loading,
  ComposedModal,
  ModalBody,
  ModalFooter,
  Checkbox,
  InlineNotification,
  ModalHeader,
  RadioButton,
  RadioButtonGroup,
  Select,
  SelectItem
} from 'carbon-components-react';
import axios from 'axios';
import { ArrowRight32 } from '@carbon/icons-react';
import { Dropdown } from 'carbon-components';

type CobrandsLoginProps = {
  usernameLabel: string;
  usernamePlaceholder: string;
  passwordLabel: string;
  passwordPlaceholder: string;
  submitLabel: string;
  loginFormUrl: string;
  buttonLoadingText: string;
  labelDemoUat: string;
  labelUat: string;
  labelProd: string;
  labelLocal: string;
  applicationNameEndpoint: string;
  applicationToolsEndpoint: string;
  assoicateSsoSubmitEndpoint: string;
};

const CobrandsLogin = ({
  usernameLabel,
  usernamePlaceholder,
  passwordLabel,
  passwordPlaceholder,
  submitLabel,
  loginFormUrl,
  buttonLoadingText,
  labelDemoUat,
  labelUat,
  labelProd,
  labelLocal,
  applicationNameEndpoint,
  applicationToolsEndpoint,
  assoicateSsoSubmitEndpoint
}: CobrandsLoginProps) => {
  const [isSubmitting, setSubmitState] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [errorContent, setErrorContent] = useState(null);
  const [modalErrorContent, setModalErrorContent] = useState(null);
  const [environmentValue, setEnvironment] = useState(null);
  const [appNameData, setAppNameData] = useState([]);
  const [appToolData, setToolData] = useState([]);
  const [selectedApp, setSelectedAppName] = useState('');
  const [selectedTool, setSelectedTool] = useState('');
  const [radioButtonFields, setRadioButtonFields] = useState([]);
  const fingerprintField = document.getElementById(
    'var_field'
  ) as HTMLInputElement;

  const TextInputProps = {
    className: 'login-cobrands__input-container',
    id: 'username',
    labelText: usernameLabel,
    placeholder: usernamePlaceholder
  };

  const PasswordProps = {
    className: 'login-cobrands__input-container',
    id: 'password',
    labelText: passwordLabel,
    placeholder: passwordPlaceholder
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    let fingerprint = null;

    //@ts-ignore - ignoring this bit as we are using 3rd party code to get a browser finger print and need to access it this way
    if (fingerprintField && window.var_ns) {
      //@ts-ignore
      window.var_ns.data_parse('var_field');

      fingerprint = fingerprintField.value;
    }

    setSubmitState(true);
        
    axios
      .post(loginFormUrl, {
        username: event.target.username.value,
        password: event.target.password.value,
        fingerprint: fingerprint
      })
      .then(function (response) {
        if (response.data.redirectUrl) {
          window.location.href = response.data.redirectUrl;
        } else if (response.data.hasOwnProperty('demoRemainingDays')) {
          setModalContent({
            type: 'demo',
            ...response.data
          });
          setModalOpen(true);
        } else if (response.data.isAssociate) {
          response.data.currentEnvironment ? (setEnvironmentValue(response.data.currentEnvironment, '')): '';
          response.data.currentApp ? (setInitialLoadApp(response.data.currentApp)): '';
          response.data.ssoOptions ? (handleSiteToolSetup(event)) : null;
          if (radioButtonFields.length == 0) {
            radioButtonFields.push({
              label: response.data.labelDemoUat,
              id: 'envirDemoUat',
              value: 'demouat'
            });
            if(response.data.showLocal) {
              radioButtonFields.push({
                label: response.data.labelLocal,
                id: 'labelLocal',
                value: 'local'
              });
            } 
            if(response.data.showQa) {
              radioButtonFields.push({
                label: response.data.labelIntegration,
                id: 'envirIntegration',
                value: 'integration'
              });
            } 
            if(response.data.showUat) {
              radioButtonFields.push({
                label: response.data.labelUat,
                id: 'envirUat',
                value: 'uat'
              });
            } 
            radioButtonFields.push({
              label: response.data.labelProd,
              id: 'envirProd',
              value: 'prod'
            });
          }
          
          setRadioButtonFields(radioButtonFields);

          setModalContent({
            type: 'associate',
            ...response.data
          });
          setModalOpen(true);
        } else if (response.data.securityQuestionEndpoint) {
          setModalContent({
            type: 'security',
            ...response.data
          });
          setModalOpen(true);
        } else if (response.data.message) {
          setErrorContent(response.data.message);
        }

        setSubmitState(false);
      })
      .catch(function (error) {
        setSubmitState(false);
      });
  };

  const handleSiteToolSetup = async (event: any) => {
    axios
      .get(applicationToolsEndpoint)
      .then( function (response) {
        if (response.data) {
          setToolData(response.data.options);
        }
      })
  };
  const setSelectedApp = async (event: any) => {
      setSelectedAppName(event.currentTarget.value);
  };

  const setInitialLoadApp = async (value: string) => {
    setSelectedAppName(value);
  }

  const handleSelectedTool = async (event: any) => {
      setSelectedTool(event.currentTarget.value);
  };

  const handleAssociateSubmit = (event: any) => {
    event.preventDefault();
    var manualSite = event.target.txtSite ? event.target.txtSite.value : '';
    var manualUser = event.target.txtUser ? event.target.txtUser.value : '';
    var useTool = selectedTool;
    var localSelectedApp = selectedApp;
    var localEnvironment = environmentValue;

    axios
      .post(assoicateSsoSubmitEndpoint,{
        inputUser: manualUser,
        siteUrl: manualSite,
        appName: localSelectedApp,
        selectedTool: useTool,
        selectedEnvironment: localEnvironment
      })
      .then(function (response) {
        if (response.data.redirectUrl) {
          window.location.href = response.data.redirectUrl;
        }
      }
    )
  };

  const setEnvironmentValue = async (value: string, name: string) => {
      if (value == null){
        value = 'demouat';
      }
      setEnvironment(value);

      axios
        .get(applicationNameEndpoint + '?id=' + environmentValue)
        .then(function (response) {
          if (response.data) {
            setAppNameData(response.data.options)
          }
        })
  };

  const handleSecurityQuestionSubmit = (event: any) => {
    event.preventDefault();

    let fingerprint = null;

    //@ts-ignore - ignoring this bit as we are using 3rd party code to get a browser finger print and need to access it this way
    if (fingerprintField && window.var_ns) {
      fingerprint = fingerprintField.value;
    }

    axios
      .post(modalContent.securityQuestionEndpoint, {
        answer: event.target.answer.value,
        rememberDevice: event.target.rememberDevice.checked,
        questionId: modalContent.questionId,
        fingerprint: fingerprint
      })
      .then(function (response) {
        if (response.data.redirectUrl) {
          window.location.href = response.data.redirectUrl;
        } else if (response.data.securityQuestionEndpoint) {
          setModalContent({
            type: 'security',
            ...response.data
          });
          setModalOpen(true);
        } else if (response.data.message) {
          setModalErrorContent(response.data.message);
        }
      })
      .catch(function (error) {});
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <TextInput required {...TextInputProps} />

        <TextInput type="password" required {...PasswordProps} />

        {errorContent && (
          <InlineNotification
            kind="error"
            title={errorContent}
            role="alert"
            lowContrast
            hideCloseButton
          ></InlineNotification>
        )}

        {isSubmitting ? (
          <div className="login-cobrands__submitting">
            <Loading
              withOverlay={false}
              active={true}
              small={true}
              className="login-cobrands__submitting-image"
            />
            <span className="login-cobrands__submitting-text">
              {buttonLoadingText}
            </span>
          </div>
        ) : (
          <Button type="submit" className="some-class">
            {submitLabel}{' '}
            <ArrowRight32 className="login-cobrands__arrowicon bx--btn__icon" />
          </Button>
        )}
      </Form>

      {modalContent && modalContent.type === 'demo' && (
        <ComposedModal
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          size="sm"
          className="security-question-modal"
        >
          <ModalHeader className="security-question-modal__header-wrapper">
            <h3 className="security-question-modal__header">
              {modalContent.demoTitle}
            </h3>
          </ModalHeader>
          <ModalBody>
            <div>{modalContent.demoDescription}</div>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                if (modalContent.demoRemainingDays > 0) {
                  if (!!modalContent.securityQuestionEndpoint) {
                    setModalContent((prev: any) => ({
                      ...prev,
                      type: 'security'
                    }));
                  } else {
                    window.location.href =
                      modalContent.demoLoginSuccessRedirectUrl;
                  }
                } else {
                  setModalOpen(false);
                }
              }}
              kind="secondary"
            >
              {modalContent.demoExitButtonText}
            </Button>
            <Button
              onClick={() => {
                window.location.href = modalContent.demoSignUpRedirectUrl;
              }}
              kind="primary"
            >
              {modalContent.demoContinueButtonText}
            </Button>
          </ModalFooter>
        </ComposedModal>
      )}

      {modalContent && modalContent.type === 'security' && (
        <ComposedModal
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          size="sm"
          className="security-question-modal"
        >
          <ModalHeader className="security-question-modal__header-wrapper">
            <h3 className="security-question-modal__header">
              {modalContent.title}
            </h3>
          </ModalHeader>
          <Form onSubmit={handleSecurityQuestionSubmit}>
            <ModalBody>
              <TextInput
                required
                className="security-question-modal__input"
                id="answer"
                labelText={modalContent.question}
                placeholder={modalContent.inputPlaceholder}
                key={new Date().getTime()}
              />

              <Checkbox
                className="security-question-modal__checkbox"
                labelText={modalContent.rememberDeviceText}
                id="rememberDevice"
              />

              {modalErrorContent && (
                <InlineNotification
                  kind="error"
                  title={modalErrorContent}
                  role="alert"
                  lowContrast
                  hideCloseButton
                ></InlineNotification>
              )}
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => setModalOpen(false)} kind="secondary">
                {modalContent.exitButtonText}
              </Button>
              <Button type="submit" kind="primary">
                {modalContent.continueButtonText}
              </Button>
            </ModalFooter>
          </Form>
        </ComposedModal>
      )}

      {modalContent && modalContent.type === 'associate' && (
        <ComposedModal
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          size="sm"
          className="security-question-modal"
        >
          <ModalHeader className="associate-question-modal__header-wrapper">
            <h3 className="security-question-modal__header">
              {modalContent.title}
            </h3>
          </ModalHeader>
          <Form onSubmit={handleAssociateSubmit}>
            <ModalBody>
              <RadioButtonGroup
                legendText="Select an Environment"
                name="environment-selection"
                orientation="vertical"
                className="environment__selection-filter"
                defaultSelected={modalContent.currentEnvironment ? modalContent.currentEnvironment : ''}
                onChange={setEnvironmentValue}
              >
                {
                  radioButtonFields.length > 0 ?
                  (
                    radioButtonFields.map((option: { label: string; id: string; value: string}) => (
                      <RadioButton
                        labelText={option.label} value={option.value} id={option.id} className='security-question-modal__radio'
                      />
                    ))
                  ) : <RadioButton labelText={modalContent.currentEnvironment}  value={modalContent.currentEnvironment} id={modalContent.currentEnvironment} className='security-question-modal__radio' />
                }

              </RadioButtonGroup>

              <Select
                id="applicationSelect"
                labelText="Select a Site"
                defaultValue={modalContent.currentApp ? modalContent.CurrentApp : ''}
                className="security-question-modal__select"
                onChange={setSelectedApp}
              >
                
                {
                  appNameData.length > 0 ? (
                  appNameData.map((option: { label: string; value: string }) => (
                    <SelectItem key={option.value} text={option.label} value={option.value} selected={(option.value == modalContent.currentApp) ? true : false}/>
                  ))
                ) : <SelectItem key='default' text='Please select environment' value='' />
                } 
              </Select>
              { modalContent.ssoOptions ? (
              <>
              <TextInput
                type="text"
                id="txtUser"
                className="security-question-modal__input"
                labelText="SSO as User"
              />

              { (modalContent.ssoOptions && modalContent.ssoOptionsDev) ? (

                <> 
                  <TextInput
                    type="text"
                    id="txtSite"
                    className="security-question-modal__input"
                    labelText="Other site URL (Manually entered)"
                  />
                  <Select
                    id="toolSelect"
                    labelText="Select a Tool"
                    className="security-question-modal__select"
                    onChange={handleSelectedTool}
                  >
                    {
                      appToolData.length > 0 ? (
                        appToolData.map((option: { label: string; value: string }) => (
                          <SelectItem key={option.value} text={option.label} value={option.value} />
                        ))
                      ) :
                      <SelectItem value="" text="No Tools available" />
                      }
                  </Select>
                </>
                ): null}
              </>
              ) : null }

              {modalErrorContent && (
                <InlineNotification
                  kind="error"
                  title={modalErrorContent}
                  role="alert"
                  lowContrast
                  hideCloseButton
                ></InlineNotification>
              )}
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => setModalOpen(false)} kind="secondary">
                {modalContent.exitButtonText}
              </Button>
              <Button type="submit" kind="primary">
                {modalContent.continueButtonText}
              </Button>
            </ModalFooter>
          </Form>
        </ComposedModal>
      )}
    </>
  );
};

export default CobrandsLogin;
